<template>
    <ElConfigProvider :button="buttonConfig" :locale="zhCn">
        <RouterView />
    </ElConfigProvider>
</template>

<script setup lang="ts">
import { ElConfigProvider } from "element-plus";
import zhCn from "element-plus/es/locale/lang/zh-cn";
import Tenant from "@/function/tenant";

const buttonConfig = { autoInsertSpace: false };
zhCn.el.pagination = Object.assign(zhCn.el.pagination, { goto: "转到" });

Tenant.getInstance().init();
</script>
